import { ORDER_STATUS } from "../model/order";
import { getLocalizedString } from "./getLocalizedString";

export function getFilterToChips(filter, listFilters) {
  const lang = localStorage.getItem("B2BLanguage") == "ITA" ? "it" : "en";
  let chips = [null, null, null, null]; //status, typeId, line, season,
  if (filter.status || filter.status === 0) {
    chips[0] = {
      value: "status",
    };
    switch (filter.status) {
      case 100:
        chips[0].text = getLocalizedString("Tutti gli stati");
        break;
      case ORDER_STATUS.DRAFT:
        chips[0].text = getLocalizedString("Recap draft");
        break;
      case ORDER_STATUS.SUBMITTED:
        chips[0].text = getLocalizedString("Recap draft waiting/singular");
        break;
      case ORDER_STATUS.CONFIRMED:
        chips[0].text = getLocalizedString("Recap draft confirmed/singular");
        break;
      case ORDER_STATUS.CANCELLED:
        chips[0].text = getLocalizedString("Recap draft cancelled/singular");
        break;
      default:
        chips[0] = null;
        break;
    }
  }
  if (filter.typeId) {
    chips[1] = {
      value: "typeId",
    };
    switch (filter.typeId) {
      case "all":
        chips[1].text = getLocalizedString("Tutti i tipi");
        break;
      case 1:
        chips[1].text = getLocalizedString("RECAP_TYPE_REORDER");
        break;
      case 2:
        chips[1].text = getLocalizedString("RECAP_TYPE_SWAP");
        break;
      default:
        chips[1] = null;
        break;
    }
  }
  if (filter.line) {
    chips[2] = {
      value: "line",
    };
    if (filter.line === "all")
      chips[2].text = getLocalizedString("Tutte le linee");
    else {
      const value = listFilters?.lines?.find(
        (elFilter) => elFilter.id == filter.line,
      );
      if (value) chips[2].text = value.labels[lang];
      else chips[2] = null;
    }
  }

  if (filter.season) {
    chips[3] = {
      value: "season",
    };
    if (filter.season === "all")
      chips[3].text = getLocalizedString("Tutte le stagioni");
    else {
      const value = listFilters?.seasons?.find(
        (elFilter) => elFilter.id === filter.season,
      );
      if (value) chips[3].text = value.labels[lang];
      else chips[3] = null;
    }
  }

  return chips;
}

export function rmvFilter(filterCode, filters) {
  switch (filterCode) {
    case "typeId":
      return { ...filters, typeId: "-" };
    case "line":
      return { ...filters, line: "-" };
    case "season":
      return { ...filters, season: "-" };
    case "status":
      return { ...filters, status: "-" };
    default:
      return filters;
  }
}
